<script>
import axios from "axios";
import {OpsPath} from "@/path";
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch.vue";
import Swal from "sweetalert2";
export default {
  computed: {
    OpsPath() {
      return OpsPath
    }
  },
  props : ['selected_item'],
  components: {SelectWithSearch},
  data(){
    return {
      selectedOpG : null,
      base_url : process.env.VUE_APP_API_BACKEND_URL,
      opgs : [],
      fields : ["title","description","modifier_type","actions"],
      key : 0,
      filter: [],
      opg : null
    }
  },
  mounted() {
    this.getOps();
  },
  methods : {
    reload(){
      this.getOps();
    },
    setEdit(v){
      this.addModifier();
      this.selectedOpG = v;
      this.key +=1;
    },
    addModifier(){
      this.$bvModal.show('bv-add-options-group');
    },
    uploadToUP(v){
      this.selectedOpG = v;
      this.key +=1;
      this.$bvModal.show('bv-upload-opg');
    },
    async getOps(){
      try {
        let res = await axios.get(this.base_url  + OpsPath.GETOPGS,{
          params : {
            item_id: this.selected_item.id
          }
        });
        if(res.data.status){
          this.opgs = res.data.data;
        }
      }catch (e) {
        console.log(e);
      }
    },
    async deleteItemTag(id){
      try {
        let d = {
          'item_id' : this.selected_item.id,
          'ids' : [id],
          'type' : 'delete'
        };
        let res = await axios.post(this.base_url + OpsPath.ITEM_TAG_OPG,d);
        if(res.data.status){
          Swal.fire('success','','success');
          this.getOps();
        }
      }catch (e){
        console.log(e)
      }
    },
    async saveItemTag(){
      try {
        let d = {
            'item_id' : this.selected_item.id,
            'ids' : [this.opg]
          };
        let res = await axios.post(this.base_url + OpsPath.ITEM_TAG_OPG,d);
        if(res.data.status){
          Swal.fire('success','','success');
          this.opg = null;
          this.getOps();
        }
      }catch (e){
        console.log(e);
      }
    }
  }
}
</script>

<template>
  <div>
    <b-row class="mb-2">
      <b-col sm="2">
        <label>Modifier Groups</label>
      </b-col>
      <b-col sm="4">
        <select-with-search :search_api="OpsPath.SEARCHOPGS" track_by="id" display="title" @selectedOption="((v) => opg = v)"></select-with-search>
      </b-col>
      <b-col sm="4">
        <b-button class="mt-1" @click="saveItemTag" size="sm" variant="success">Attach Modifier Group</b-button>
      </b-col>
    </b-row>
    <div class="table-responsive mb-0">
      <b-table
          :key="opgs.key"
          :items="opgs.data"
          :fields="fields"
          responsive="sm"
          :per-page="opgs.per_page"
          :filter="filter"
          :current-page="opgs.current_page"
      >
        <template v-slot:cell(modifier_type)="row">
          <b-tag v-if="row.item.ake == false">Add On</b-tag><b-tag v-else>Variant</b-tag>
        </template>
        <template v-slot:cell(locations)="row">
          <template v-if="row.item.locations">
            <b-tag v-for="(l,li) in row.item.locations" :key="li">{{l.name}}</b-tag>
          </template>
        </template>
        <template v-slot:cell(actions)="row">
          <b-button @click="deleteItemTag(row.item.id)" variant="danger" class="ml-1">
            <i class="fa fa-trash"></i>
          </b-button>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination :key="opgs.key" v-model="opgs.current_page" :total-rows="opgs.total" :per-page="opgs.per_page"></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style>

</style>